import { currentIntlLocale } from '@/app/i18n'
import { monthStart, shiftDay, tenantToday } from '@/shared/lib/tenantDay'

export interface HistoryPeriod {
  from: string
  to: string
}

export const PERIOD_PRESETS = ['days30', 'days90', 'thisMonth', 'lastMonth'] as const
export type PeriodPreset = (typeof PERIOD_PRESETS)[number]

export function presetPeriod(preset: PeriodPreset, today: string = tenantToday()): HistoryPeriod {
  switch (preset) {
    case 'days30':
      return { from: shiftDay(today, -29), to: today }
    case 'days90':
      return { from: shiftDay(today, -89), to: today }
    case 'thisMonth':
      return { from: monthStart(today), to: today }
    case 'lastMonth': {
      const end = shiftDay(monthStart(today), -1)
      return { from: monthStart(end), to: end }
    }
  }
}

export function matchingPreset(
  period: HistoryPeriod,
  today: string = tenantToday(),
): PeriodPreset | null {
  return (
    PERIOD_PRESETS.find((preset) => {
      const candidate = presetPeriod(preset, today)
      return candidate.from === period.from && candidate.to === period.to
    }) ?? null
  )
}

export function formatDay(day: string): string {
  const date = new Date(`${day}T00:00:00Z`)
  if (Number.isNaN(date.getTime())) return day
  return new Intl.DateTimeFormat(currentIntlLocale(), {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC',
  }).format(date)
}
